import WidgetModule from "@eisinc/Overrides/Widgets/CheckoutReviewAndSubmit/PickUpLocation";

export * from "@eisinc/Overrides/Widgets/CheckoutReviewAndSubmit/PickUpLocation";

export default WidgetModule;
